/**
 * navigation.ts — SPA-навигация на страницу товара
 * Проект: TorgiRT (shared — все витрины)
 */

import { state, productLookup, BASE_PATH } from './state';
import { normalizeProduct, getConfig } from './helpers';
import { closeProductModal } from './modal';
import { render } from './render';
import { rememberSpaProductScroll } from './spa-back-scroll';

export async function navigateToProduct(article: string): Promise<void> {
  const cached = productLookup.get(article);
  if (cached && (cached as { id?: number }).id) {
    rememberSpaProductScroll();
    state.productPage = cached as any;
    state.productPageImageIndex = 0;
    history.pushState(null, '', BASE_PATH + '/product/' + encodeURIComponent(article));
    closeProductModal();
    render();
    window.scrollTo(0, 0);
    return;
  }
  const jsonUrl = getConfig("ajaxProductJsonUrl", "") as string;
  try {
    const res = await fetch(jsonUrl + "?article=" + encodeURIComponent(article));
    if (!res.ok) throw new Error("HTTP " + res.status);
    const data = await res.json();
    const product = normalizeProduct(data) as any;
    product.characteristics = data.characteristics || {};
    productLookup.set(product.article, product);
    state.productPage = product;
    state.productPageImageIndex = 0;
    rememberSpaProductScroll();
    history.pushState(null, '', BASE_PATH + '/product/' + encodeURIComponent(article));
    closeProductModal();
    render();
    window.scrollTo(0, 0);
  } catch {
    window.location.href = BASE_PATH + '/product/' + encodeURIComponent(article);
  }
}
